import React from 'react';

const LabCardGeneric = ({ lab, onClick }) => {
	return (
		<div
			id={`lab-card-${lab.cnpj || lab.nome}`}
			className="labChooseCard"
			role="button"
			tabIndex={0}
			onClick={(e) => {
				e.preventDefault();
				onClick();
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					onClick();
				}
			}}
		>
			{lab.logo ? (
				<img
					className="labChooseCard__img"
					src={lab.logo}
					id={lab.nome}
					alt={lab.nome}
				/>
			) : (
				<span className="labChooseCard__text">
					{lab.nome}
				</span>
			)}
		</div>
	);
};

export default LabCardGeneric;
